// export const iconData = [
//   {
//     id: 0,
//     icon: "/images/jpg file.svg",
//     extension: "jpg",
//   },
//   {
//     id: 1,
//     icon: "/images/jpg file.svg",
//     extension: "jpeg",
//   },
//   {
//     id: 2,
//     icon: "/HwImg/xlsx.svg",
//     extension: "xlsx",
//   },
//   {
//     id: 3,
//     icon: "/images/xsl.svg",
//     extension: "xls",
//   },
//   {
//     id: 4,
//     icon: "/images/doc file.svg",
//     extension: "doc",
//   },
//   {
//     id: 5,
//     icon: "/images/pdf file.svg",
//     extension: "pdf",
//   },
//   {
//     id: 6,
//     icon: "/images/png file.svg",
//     extension: "png",
//   },
//   {
//     id: 7,
//     icon: "/images/doc file.svg",
//     extension: "docx",
//   },
// ];
export const iconData = [
  {
    id: 0,
    icon: "/images/jpg.svg",
    extension: "jpg",
  },
  {
    id: 1,
    icon: "/images/jpg.svg",
    extension: "jpeg",
  },
  {
    id: 2,
    icon: "/images/doc.svg",
    extension: "doc",
  },
  {
    id: 3,
    icon: "/images/xsl.svg",
    extension: "xlsx",
  },
  {
    id: 4,
    icon: "/images/xsl.svg",
    extension: "xls",
  },
  {
    id: 5,
    icon: "/images/Word_logo.png",
    extension: "doc",
  },
  {
    id: 6,
    icon: "/images/Word_logo.png",
    extension: "docx",
  },
  {
    id: 7,
    icon: "/images/pdf.png",
    extension: "pdf",
  },
  {
    id: 8,
    icon: "/images/png.png",
    extension: "png",
  },
  {
    id: 9,
    icon: "/images/mp3.svg",
    extension: "mp3",
  },
  {
    id: 10,
    icon: "/images/mp4.svg",
    extension: "mp4",
  },
  // Entries with extensions in capital letters
  {
    id: 11,
    icon: "/images/jpg.svg",
    extension: "JPG",
  },
  {
    id: 12,
    icon: "/images/doc.svg",
    extension: "DOC",
  },
  {
    id: 13,
    icon: "/images/xsl.svg",
    extension: "XLSX",
  },
  {
    id: 14,
    icon: "/images/xsl.svg",
    extension: "XLS",
  },
  {
    id: 15,
    icon: "/images/Word_logo.png",
    extension: "DOCX",
  },
  {
    id: 16,
    icon: "/images/pdf.png",
    extension: "PDF",
  },
  {
    id: 17,
    icon: "/images/png.png",
    extension: "PNG",
  },
  {
    id: 18,
    icon: "/images/mp3.svg",
    extension: "MP3",
  },
  {
    id: 19,
    icon: "/images/mp4.svg",
    extension: "MP4",
  },
  {
    id: 20,
    icon: "/images/ppt.svg",
    extension: "ppt",
  },
  {
    id: 21,
    icon: "/images/ppt.svg",
    extension: "pptx",
  },
  {
    id: 22,
    icon: "/images/ppt.svg",
    extension: "PPT",
  },
  {
    id: 23,
    icon: "/images/ppt.svg",
    extension: "PPTX",
  },
];
